import type { SubscriptionDto } from '@str/api/types';

const BRAND_LABEL: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'Amex',
  discover: 'Discover',
  diners: 'Diners',
  jcb: 'JCB',
  unionpay: 'UnionPay',
};

export function cardBrandLabel(brand: string | null | undefined) {
  if (!brand) return 'Card';
  return BRAND_LABEL[brand] ?? brand.charAt(0).toUpperCase() + brand.slice(1);
}

/** 'expired' | 'expiring' (within ~60 days) | 'ok' | null when no expiry is known. */
export function cardExpiryState(
  sub: Pick<SubscriptionDto, 'cardExpMonth' | 'cardExpYear'>,
  now = new Date(),
): 'expired' | 'expiring' | 'ok' | null {
  if (!sub.cardExpMonth || !sub.cardExpYear) return null;
  // Cards are valid through the last day of the expiry month.
  const expiresAt = new Date(sub.cardExpYear, sub.cardExpMonth, 0, 23, 59, 59);
  if (expiresAt < now) return 'expired';
  const soon = new Date(now.getTime() + 60 * 86_400_000);
  return expiresAt < soon ? 'expiring' : 'ok';
}

export function cardExpiryLabel(sub: Pick<SubscriptionDto, 'cardExpMonth' | 'cardExpYear'>) {
  if (!sub.cardExpMonth || !sub.cardExpYear) return null;
  return `${String(sub.cardExpMonth).padStart(2, '0')}/${String(sub.cardExpYear).slice(-2)}`;
}
